import axios from "axios";

const BASE_HATTRICK_URL = import.meta.env.VITE_HATTRICK_URL;

const encodeBase64 = (data) => {
    return btoa(JSON.stringify(data));
};

export const getTeamGear = (school, user) => {
    let headers = {
        "Content-Type": "application/json",
        Authorization: "Bearer " + user.stsTokenManager.accessToken,
    }

    const params = {
        school_name: encodeBase64(school),
    };

    return axios.get(BASE_HATTRICK_URL + "team/get",
        {
            headers,
            params
        }
    );
}

export const getTeamSchoolAndSportList = (user) => {
    let headers = {
        "Content-Type": "application/json",
        Authorization: "Bearer " + user.stsTokenManager.accessToken,
    }

    return axios.get(BASE_HATTRICK_URL + "team/getSchoolAndSportList",
        { headers }
    );
}

export const createNewTeamGear = (file, team, user) => {

    const formData = new FormData();
    formData.append("file", file);
    formData.append("team", JSON.stringify(team));

    let config = {
        headers: {
            Authorization: "Bearer " + user.stsTokenManager.accessToken,
        },
    };

    return axios.post(BASE_HATTRICK_URL + "team/create", formData, config);
};

export const updateTeamGear = (team, user) => {

    let config = {
        headers: {
            Authorization: "Bearer " + user.stsTokenManager.accessToken,
        },
    };

    return axios.post(BASE_HATTRICK_URL + "team/update", team, config);
};